module.exports = __webpack_public_path__ + "static/media/main idea.046a5901.mp3";